import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

export const TRIAL_ONBOARDING_MODAL_ID: string = 'trial-onboarding-modal';

export const trialOnboardingModalConfig: { showLimit: number; closeLimit: number; showInterval: number } = getFeature(
    `${TRIAL_ONBOARDING_MODAL_ID}-config`
) || {
    showLimit: 3,
    closeLimit: 1,
    showInterval: 60 * 60 * 24 * 3,
};

export const trialOnboardDatalistItem: boolean = isFeature('trial-onboard-datalist-item-enable');
